import { useQuery } from "@tanstack/react-query";
import { getOnboardingProgress, type OnboardingProgress } from "@/api/client";

export const ONBOARDING_PROGRESS_QUERY_KEY = ["onboarding-progress"] as const;

export function useOnboardingProgress() {
  return useQuery<OnboardingProgress>({
    queryKey: ONBOARDING_PROGRESS_QUERY_KEY,
    queryFn: getOnboardingProgress,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
